var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12e_admin_users_edit_inactive",
    transform: "translate(-235.000000, -160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(235.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#37652C",
    cx: 15,
    cy: 15,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 11.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2499709,8.99999569 L0.750003231,8.99999569 C0.335773342,8.99999569 0,8.66420129 0,8.24999785 C0,7.8357944 0.335773342,7.49999569 0.750003231,7.49999569 L11.2499968,7.49999569 C11.6642008,7.49999569 12,7.8357944 12,8.24999785 C12,8.66420129 11.6642008,8.99999569 11.2499709,8.99999569 Z M11.2499709,5.24998923 L0.750003231,5.24998923 C0.335773342,5.24998923 0,4.91421637 0,4.50001293 C0,4.08580948 0.335773342,3.75001077 0.750003231,3.75001077 L11.2499968,3.75001077 C11.6642008,3.75001077 12,4.08578363 12,4.50001293 C12,4.91424222 11.6642008,5.24998923 11.2499709,5.24998923 Z M11.2499709,1.5 L0.750003231,1.5 C0.335773342,1.5 0,1.16423145 0,0.750002154 C0,0.33577286 0.335773342,0 0.750003231,0 L11.2499968,0 C11.6642008,0 12,0.33577286 12,0.750002154 C12,1.16423145 11.6642008,1.5 11.2499709,1.5 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMenu);
export default __webpack_public_path__ + "static/media/show-menu.3ff4d41aa23db7dc28f2280cdf570110.svg";
export { ForwardRef as ReactComponent };